import { WebsiteInput as StyleguideWebsiteInput, useTranslator } from "@sia/style-guide";

export const WebsiteInput = (props) => {
  const translate = useTranslator();
  const invalidPatternText = translate("form.input.error.invalid.with-example", { example: translate("form.input.error.invalid.example.website") });
  const enrichingProps = { invalidPatternText: invalidPatternText };
  const enrichedProps = { ...props, ...enrichingProps };
  return <StyleguideWebsiteInput {...enrichedProps} />;
};
